export type LanguageType = 'de' | 'en' | 'es' | 'fr' | 'pt' | 'ru'

export const languages: Record<LanguageType, string> = {
  de: 'Deutsch',
  en: 'English',
  es: 'Español',
  fr: 'Français',
  pt: 'Português',
  ru: 'Русский'
}

export const languagePrefixes = Object.keys(languages) as LanguageType[]
